import { sanitizeAgentMessageHtml } from "../utils/sanitizeAgentMessageHtml";

interface SanitizedHtmlMessageProps {
  content: string;
  onLinkClick: (url: string, linkText: string) => void;
}

export function SanitizedHtmlMessage({
  content,
  onLinkClick,
}: SanitizedHtmlMessageProps) {
  return (
    <div
      className="prose prose-sm max-w-none wrap-break-word text-base leading-[1.21] text-black [&_a]:text-blue-600 [&_a]:underline [&_a]:decoration-1 [&_a]:underline-offset-2 [&_a:hover]:text-blue-800 [&_a:visited]:text-violet-700 [&_a:focus-visible]:rounded-sm [&_a:focus-visible]:outline-none [&_a:focus-visible]:ring-2 [&_a:focus-visible]:ring-blue-600 [&_a:focus-visible]:ring-offset-2 [&_p]:mb-4 [&_p]:whitespace-pre-wrap [&_p]:leading-[1.21] [&_p:last-child]:mb-0"
      dangerouslySetInnerHTML={{ __html: sanitizeAgentMessageHtml(content) }}
      onClick={(event) => {
        const anchor = (event.target as HTMLElement).closest("a");
        if (!anchor) return;

        onLinkClick(anchor.href, anchor.textContent || "link");
      }}
    />
  );
}
